import styles from "./Homepage2.module.scss";
import ContactForm from "../../components/FormContact/ContactForm";

// NUOVE SEZIONI (cartella src/nuove-sezioni)
// import { ChiSono, Servizi, Lavori } from "../nuove-sezioni";

// la tua foto: la stessa che usavi già in alto
import three from "../../assets/three.jpeg";
import ChiSono from "../nuove-sezioni/Chisono/ChiSono";
import Servizi from "../nuove-sezioni/Servizi/Servizi";
import Lavori from "../nuove-sezioni/Lavori/Lavori";

// ---------------------------------------------------------------
// VECCHIE SEZIONI: non le ho cancellate, le trovi in fondo al file
// commentate. Se ne rivuoi una, togli il commento e rimetti il suo
// import qui sopra.
// ---------------------------------------------------------------

const Homepage = () => {
  return (
    <div className={styles["homepage"]}>
      {/* CHI SONO: "Ciao, sono Agnese", 4 capitoli, citazione, come lavoro */}
      <ChiSono foto={three} />

      {/* COSA POSSO FARE */}
      <Servizi />

      {/* LAVORI SELEZIONATI (id "projects" tenuto per i link del menu) */}
      <div id="projects">
        <Lavori />
      </div>

      {/* FORM CONTATTI: è il tuo, invariato */}
      {/* <Reveal>
        <h3 id="contatti" className={styles["homepage__title"]}></h3>
      </Reveal> */}
      <div id="contatti">
        <ContactForm />
      </div>
    </div>
  );
};

export default Homepage;

/* =================================================================
   VECCHIE SEZIONI (disattivate)
   -----------------------------------------------------------------
   Import che servivano:
     import CarouselSkills from "../../components/CarouselSkills/CarouselSkills";
     import Project from "../../components/Project/Project";
     import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
     import { faUser, faCakeCandles, faLocationDot, faGraduationCap,
              faMountainSun, faBicycle, faBriefcase } from "@fortawesome/free-solid-svg-icons";
     import mail from "../../assets/info/mail.png";
     import html from "../../assets/icons/html.png";  (e le altre icone skills)

   Intestazione:
      <div className={styles["homepage__inline-header"]}>
        <img className={styles["homepage__img"]} src={three} alt="100" />
        <Reveal>
          <h2 className={styles["homepage__presentation"]}>
            Ciao! Mi chiamo <strong>Agnese</strong> e sono una{" "}
            <span className={styles["homepage__strong"]}>Sviluppatrice Web</span>
            <br />e una <span className={styles["homepage__strong"]}>Social Media Manager</span>
          </h2>
        </Reveal>
      </div>

   Competenze:
      <Reveal>
        <h3 id="skills" className={styles["homepage__title"]}>COMPETENZE</h3>
      </Reveal>
      <CarouselSkills />
      <div className={styles["homepage__align-skills"]}>
        <img src={html} alt="20" height={70} />  ...e le altre icone
      </div>

   Progetti:
      <Reveal>
        <h3 id="projects" className={styles["homepage__title"]}>PROGETTI</h3>
      </Reveal>
      <Project />

   Il riquadro con Nome / Compleanno / Luogo / Studi / Interessi /
   GitHub / Email / Hobbies è stato sostituito dalla nuova sezione
   Chi sono. Il codice originale è nella tua cronologia Git.
   ================================================================= */
